import AddressModal from './AddressModal.view';

export default AddressModal;
